module.exports = __webpack_public_path__ + "315b500e0813a2216e38c1fa4586fba3.png";